import { AppTooltip } from '@lmt/unicorn-shared/app/components/common/ui-kit/tooltip/AppTooltip';
import ErrorIcon from '@lmt/unicorn-shared/app/icons/error-circle.svg?react';
import clsx from 'clsx';
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import styles from './ScriptInput.module.scss';

type Props = {
  predefinedText?: string;
  className?: string;
  error?: boolean;
  helperText?: string;
  shortErrorText?: string;
  fullErrorText?: string;
  onChange?: (value: string) => void;
  value?: string | null;
};

export const ScriptInput: React.FC<Props> = function TextArea(props: Props) {
  const {
    value,
    onChange,
    predefinedText,
    helperText,
    shortErrorText,
    fullErrorText,
    error,
    className,
  } = props;
  const isError = !!shortErrorText;

  return (
    <div>
      <label className={styles.area} data-error={error}>
        <div className={styles.overlayText}>{predefinedText}</div>
        <TextareaAutosize
          className={clsx(styles.hiddenTextarea, className)}
          value={value ?? ''}
          onChange={(e) => onChange?.(e.target.value)}
        />
      </label>
      {!!(helperText || shortErrorText) && (
        <div
          className={styles.helperTextContainer}
          data-error={isError.toString()}
        >
          {fullErrorText && (
            <AppTooltip title={fullErrorText}>
              <ErrorIcon className={styles.iconContainer} />
            </AppTooltip>
          )}
          <span data-error={error} className={styles.helperText}>
            {helperText || shortErrorText}
          </span>
        </div>
      )}
    </div>
  );
};
